<template>
  <div class="jjfz">
    <hljHeader :backColor="`#AC0209`"></hljHeader>
    <div class="jjfz-banner">

    </div>
    <div class="jjfz-content">
      <div class="rdbb-content">
        <div class="rdbb-title">入党必备</div>
        <div class="rdbb-main">
          <div class="rdbb-item" v-for="item in rdbbList" :key="item.id" @click="jumpDetail(item)">
            <div :style="`background-image:url(${item.photo});`"></div>
          </div>
        </div>
      </div>
      <div class="dxjy-content">
        <div class="dxjy-title">党性教育</div>
        <div class="dxjy-main">
          <div class="dxjy-item" v-for="item in dxjyList" :key="item.id" @click="jumpDetail(item)">
            <div :style="`background-image:url(${item.photo});`"></div>
          </div>
          <div class="empty-item"></div>
          <div class="empty-item"></div>
        </div>
      </div>
      <div class="xsx-content">
        <div class="xsx-title">新思想 新征程</div>
        <div class="xsx-main">
          <div class="xsx-item" v-for="item in xsxList" :key="item.id" @click="jumpDetail(item)">
            <div class="item-img">
              <div :style="`background-image:url(${item.photo});`"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="sslw-content">
        <div class="sslw-title">四史领悟</div>
        <div class="sslw-main">
          <swiper :options="sslwSwiperOption" v-if="dftsList.length">
            <swiper-slide v-for="item in sslwList" :key="item.id" :data-id="item.id">
              <div :data-id="item.id" :style="`background-image:url(${item.photo});`"></div>
            </swiper-slide>

          </swiper>
          <div class="swiper-pagination sslw"></div>
        </div>
      </div>
      <div class="dfts-content">
        <div class="dfts-title">地方特色篇</div>
        <div class="dfts-main">
          <div v-if="dftsList.length > 0" class="main-left" :style="`background-image:url(${dftsList[swiperActive].photo});`" @click="jumpDetail(dftsList[swiperActive])"></div>
          <div class="main-right">
            <swiper :options="dftsSwiperOption" v-if="dftsList.length">
              <swiper-slide v-for="item in dftsList" :key="item.id">
                <div :style="`background-image:url(${item.photo});`"></div>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination dfts"></div>
            <div class="swiper-button-next dfts"></div>
            <div class="swiper-button-prev dfts"></div>
          </div>
        </div>
      </div>
    </div>
    <hljFooter></hljFooter>
  </div>
</template>

<script>
import utils from "../../../../config/utils"
import hljHeader from "../../../../components/Custom/hlj/hlj_header.vue"
import hljFooter from "../../../../components/Custom/hlj/hlj-footer.vue"
import services from '@/config/services'
export default {
  data() {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      utils,
      sslwSwiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 300,
          depth: 280,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        pagination: {
          el: `.swiper-pagination.sslw`,
        },
        on: {
          click: (e) => {
            let id = e.target.getAttribute("data-id")
            window.open(`/center/${that.school_code}/custom/hljdypx/hljDetail?id=${id}&key=new`)
          },
        },
      },
      dftsSwiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        spaceBetween: window.innerWidth * 0.01,
        loop: true,
        slidesPerView: 3,
        direction: "vertical",
        slideToClickedSlide: true,
        navigation: {
          // 前进后退按钮 ,不同版本配置方式不同
          nextEl: `.swiper-button-next.dfts`,
          prevEl: `.swiper-button-prev.dfts`,
        },
        on: {
          slideChangeTransitionEnd: function () {
            that.swiperActive = this.realIndex
          },
        }
      },
      rdbbList: [],
      dxjyList: [],
      xsxList: [],
      sslwList: [],
      dftsList: [],
      activeItem: {},
      swiperActive: 0,
    }
  },
  components: {
    hljHeader,
    hljFooter
  },
  methods: {
    async getListData() {
      await services.getCourseList({ page: 1, size: 1, category_id: "207", school_code: this.school_code }).then(res => {
        this.rdbbList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 7, category_id: "211", school_code: this.school_code }).then(res => {
        this.dxjyList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 2, category_id: "222", school_code: this.school_code }).then(res => {
        this.xsxList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 4, category_id: "225", school_code: this.school_code }).then(res => {
        this.sslwList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 9, category_id: "233", school_code: this.school_code }).then(res => {
        this.dftsList = res.data.items
        if (this.dftsList.length > 0) {
          this.activeItem = this.dftsList[0]
        }
      })
    },
    jumpDetail(item) {
      if (item) {
        window.open(`/center/${this.school_code}/custom/hljdypx/hljDetail?id=${item.id}&key=jjfz`, "_blank")
      }
    },
  },
  created() {
    this.utils.setFonts()
    this.getListData()
  },
  mounted() {
    window.onresize = () => {
      this.utils.setFonts()
    }
  }

}
</script>
<style lang="less" scoped>
.jjfz {
  .jjfz-banner {
    height: 4.8rem;
    background-image: url("../../../../assets/custom/hlj/jjfz/jjfz-banner.png");
    width: 100%;
    background-size: cover;
    background-position: center;
  }
  .jjfz-content {
    width: 100%;
    background-image: url("../../../../assets/custom/hlj/jjfz/jjfz-bg.png");
    background-size: cover;
    background-position: top center;
    padding-top: 0.5rem;
    padding-bottom: 0.6rem;
    .rdbb-content {
      width: 12rem;
      margin: 0 auto;
      .rdbb-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;
        &::before,
        &::after {
          content: "";
          width: 4.67rem;
          height: 0.17rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/jjfz/rdbb-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .rdbb-main {
        margin-top: 0.35rem;
        width: 12rem;
        height: 5.47rem;
        background-size: cover;
        background-position: center;
        background-image: url("../../../../assets/custom/hlj/jjfz/rdbb-bg.png");
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        .rdbb-item {
          width: 7.2rem;
          height: 4.06rem;
          overflow: hidden;
          //   background-color: #c31117;
          cursor: pointer;
          &:hover {
            div {
              transform: scale(1.1);
            }
          }
          div {
            width: 100%;
            height: 100%;
            background-position: center;
            background-size: cover;
            transition: all 0.3s;
          }
        }
      }
    }
    .dxjy-content {
      width: 12rem;
      margin: 0.44rem auto 0;
      .dxjy-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;

        &::before,
        &::after {
          content: "";
          width: 4.67rem;
          height: 0.17rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/jjfz/rdbb-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .dxjy-main {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 0.36rem;
        .dxjy-item {
          width: 3.8rem;
          height: 2.14rem;
          background-color: #c31117;
          margin-bottom: 0.32rem;
          cursor: pointer;
          overflow: hidden;
          &:hover {
            div {
              transform: scale(1.1);
            }
          }
          div {
            transition: all 0.3s;
            width: 100%;
            height: 100%;
            // background-image: url("../../../../assets/");
            background-size: cover;
            background-position: center;
            background-color: #c31117;
          }
          &:nth-child(n + 4) {
            width: 2.8rem;
            height: 1.57rem;
          }
        }
        .empty-item {
          width: 3.8rem;
          &:nth-child(n + 4) {
            width: 2.8rem;
          }
        }
      }
    }
    .xsx-content {
      width: 12rem;
      margin: 1.39rem auto 0;
      .xsx-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;
        &::before,
        &::after {
          content: "";
          width: 4.19rem;
          height: 0.17rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/jjfz/xsx-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .xsx-main {
        display: flex;
        justify-content: space-between;
        margin-top: 0.36rem;
        .xsx-item {
          width: 5.8rem;
          height: 3.38rem;
          background: #bdb190;
          padding: 0.12rem;
          cursor: pointer;
          .item-img {
            width: 100%;
            height: 100%;
            overflow: hidden;
            &:hover {
              div {
                transform: scale(1.1);
              }
            }
            div {
              transition: all 0.3s;
              width: 100%;
              height: 100%;
              // background-image: url("../../../../assets/");
              background-size: cover;
              background-position: center;
              background-color: #c31117;
            }
          }
        }
      }
    }

    .sslw-content {
      width: 12rem;
      margin: 0.6rem auto 0;
      .sslw-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;
        &::before,
        &::after {
          content: "";
          width: 4.67rem;
          height: 0.17rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/jjfz/rdbb-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .sslw-main {
        margin-top: 0.36rem;
        height: 4.6rem;
        position: relative;
        .swiper-container {
          position: relative;
          .swiper-wrapper {
            .swiper-slide {
              width: 7.2rem;
              height: 4.05rem;
              cursor: pointer;
              overflow: hidden;
              &:hover {
                div {
                  transform: scale(1.1);
                }
              }
              div {
                transition: all 0.3s;
                width: 100%;
                height: 100%;
                // background-image: url("../../../../assets/");
                background-size: cover;
                background-position: center;
                background-color: #c31117;
              }
            }
          }
        }
        /deep/ .swiper-pagination {
          &.sslw {
            display: flex;
            justify-content: center;
            margin-top: 0.36rem;
            .swiper-pagination-bullet {
              display: block;
              margin: 0 0.07rem;
              width: 0.1rem;
              height: 0.1rem;
              background: #cdb29f;
              border-radius: 50%;
              &.swiper-pagination-bullet-active {
                background: #dd3639;
              }
            }
          }
        }
      }
    }
    .dfts-content {
      width: 12rem;
      margin: 0.9rem auto 0;
      .dfts-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;
        &::before,
        &::after {
          content: "";
          width: 4.67rem;
          height: 0.17rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/jjfz/rdbb-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .dfts-main {
        margin-top: 0.54rem;
        padding: 0.24rem;
        display: flex;
        background: #f5d19c;
        height: 5.25rem;
        .main-left {
          width: 8.48rem;
          height: 4.77rem;
          background-size: cover;
          background-position: center;
          cursor: pointer;
        }
        .main-right {
          flex: 1;
          margin-left: 0.6rem;
          height: 100%;
          padding: 0.3rem 0;
          position: relative;
          .swiper-container {
            overflow: hidden;
            height: 100%;
            .swiper-wrapper {
              .swiper-slide {
                cursor: pointer;
                overflow: hidden;
                &.swiper-slide-active {
                  border: 0.04rem solid #c31117;
                }
                &:hover {
                  div {
                    transform: scale(1.1);
                  }
                }
                div {
                  transition: all 0.3s;
                  width: 100%;
                  height: 100%;
                  // background-image: url("../../../../assets/");
                  background-size: cover;
                  background-position: center;
                  background-color: #c31117;
                }
              }
            }
          }
          .swiper-button-next.dfts {
            width: 0.31rem;
            height: 0.19rem;
            background-image: url("../../../../assets/custom/hlj/jjfz/dfts-next.png");
            background-position: center;
            background-size: cover;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
          }
          .swiper-button-prev.dfts {
            width: 0.31rem;
            height: 0.19rem;
            background-image: url("../../../../assets/custom/hlj/jjfz/dfts-prev.png");
            background-position: center;
            background-size: cover;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>